import * as React from 'react'
import { AttachmentTranslations } from './translations'

export * from './attachment-selector'
export * from './attachment-viewer'

export const AttachmentTranslationsCtx =
  React.createContext<AttachmentTranslations | null>(null)
export const useAttachmentTranslations = () => {
  const ctx = React.useContext(AttachmentTranslationsCtx)
  if (!ctx) {
    throw new Error('Must be used within <AttachmentTranslationsCtx.Provider>')
  }

  return ctx
}
